import cloneDeep from 'lodash/cloneDeep'
import {
  defaultSelectedGroup,
  defaultAlertCriteria,
  defaultBacktesterCriteria,
  defaultInsiderBacktesterCriteria,
  defaultInsiderBacktesterClusterCriteria
} from '@/data/constants'

import {
  defaultWhaleTraderCriteria,
  buy_signal_frequencies,
  risk_unit_types,
  existing_position_buy_actions,
  fully_invested_actions,
  volatility_time_periods,
  atr_time_periods,
  exit_time_periods,
  volume_time_periods,
  volatility_sizing
} from '@/data/whale_trader_constants'

export default () => ({
  drawer: null,
  loginDialog: false,
  notification: {
    value: false,
    type: 'error',
    text: 'Server returned an error. Please try again later.'
  },
  selectedGroup: cloneDeep(defaultSelectedGroup),
  alertCriteria: cloneDeep(defaultAlertCriteria),
  backtesterCriteria: cloneDeep(defaultBacktesterCriteria),
  insiderBacktesterCriteria: cloneDeep(defaultInsiderBacktesterCriteria),
  insiderBacktesterClusterCriteria: cloneDeep(defaultInsiderBacktesterClusterCriteria),
  etfFilter: 0,
  adrFilter: 0,
  whaleTraderCriteria: cloneDeep(defaultWhaleTraderCriteria),
  signalView: null,
  buy_signal_frequencies,
  risk_unit_types,
  existing_position_buy_actions,
  fully_invested_actions,
  volatility_time_periods,
  atr_time_periods,
  exit_time_periods,
  volume_time_periods,
  volatility_sizing,
  current_trading_model: null
})
